/** @format */

import React, { memo, ReactNode } from 'react';

import styled from 'styled-components';

import { mediaQuery } from '../../theme/mediaQuery';

// #region ::: COMPONENTS
const Wrapper = styled.div`
  position: relative;
  display: none;

  @media screen and (min-width: 1476px) {
    display: initial;
  }
`;
// #endregion

interface Props {
  children: ReactNode;
}

export const ShowOnDesktop = memo(({ children }: Props) => <Wrapper>{children}</Wrapper>);
